import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function MidPageClose() {
  const navigate = useNavigate();
  const [scanInput, setScanInput] = useState('');

  const handleScan = () => {
    if (scanInput.trim()) {
      navigate('/onboarding', { state: { businessName: scanInput.trim() } });
    } else {
      navigate('/onboarding');
    }
  };

  return (
    <section
      id="mid-page-close"
      className="flex items-center justify-center px-6"
      style={{ minHeight: '100vh', backgroundColor: '#EDE8DF' }}
      data-testid="mid-page-close"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="text-center max-w-[480px] mx-auto"
      >
        <h2
          style={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 300,
            textTransform: 'uppercase',
            letterSpacing: '0.2em',
            color: '#3C3226',
            fontSize: '32px',
            lineHeight: 1.3,
          }}
          data-testid="mid-page-headline"
        >
          DON'T WAIT TO FIND OUT WHERE YOU STAND
        </h2>

        <p
          className="mt-6 mx-auto"
          style={{
            color: '#5C5347',
            fontSize: '15px',
            fontFamily: "'DM Sans', sans-serif",
            lineHeight: 1.7,
            maxWidth: '480px',
          }}
          data-testid="mid-page-body"
        >
          87% of professionals who scan are surprised by what AI is saying
          about them. Most don't realize their competitors are already being
          mentioned.
        </p>

        {/* Scan input */}
        <div className="flex flex-col sm:flex-row items-stretch gap-0 max-w-[480px] mx-auto mt-8">
          <input
            type="text"
            value={scanInput}
            onChange={(e) => setScanInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleScan()}
            placeholder="Enter your business name or website"
            className="flex-1 px-5 py-4 text-[15px] outline-none"
            style={{
              backgroundColor: 'rgba(247,244,239,0.93)',
              border: '1px solid rgba(212,201,184,0.5)',
              borderRight: 'none',
              borderRadius: 0,
              color: '#3C3226',
            }}
            data-testid="mid-page-scan-input"
          />
          <button
            onClick={handleScan}
            className="px-8 py-4 text-[13px] font-medium uppercase tracking-widest whitespace-nowrap transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#2C2520', color: '#F0EBE3', borderRadius: 0 }}
            data-testid="mid-page-scan-btn"
          >
            Scan now <ArrowRight size={14} className="inline ml-1" />
          </button>
        </div>

        {/* Trust line */}
        <p
          className="mt-4"
          style={{
            color: '#8C7E6E',
            fontSize: '11px',
            fontFamily: "'DM Sans', sans-serif",
          }}
          data-testid="mid-page-trust"
        >
          Free. 60 seconds. No credit card.
        </p>
      </motion.div>
    </section>
  );
}
